import { Slide, createTheme } from '@mui/material';
import {DEFAULT_AUTO_HIDE_DURATION, DEFAULT_TRANSITION_DURATION} from 'contexts/SnackbarContext';
import { COLORS } from 'theme/Colors';
export { COLORS };
export { adminFontFamily } from 'theme/AdminTheme';

const MainTheme = createTheme({
  breakpoints: {
    values: {
      xxs: 0,
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1200,
      xl: 1920,
      xxl: 2560,
    },
  },
  palette: {
    primary: {
      main: COLORS.BLUE,
    },
    secondary: {
      main: COLORS.GREEN,
    },
    success: {
      main: COLORS.GREEN,
    },
    info: {
      main: COLORS.VIOLET,
    },
    warning: {
      main: COLORS.YELLOW,
    },
    error: {
      main: COLORS.RED,
    },
  },
  typography: {
    fontFamily: 'Metropolis,Roboto,Helvetica,Arial,sans-serif',
    body1: {
      color: COLORS.MAIN,
      fontSize: 16,
    },
    body2: {
      color: 'white',
      fontSize: 16,
    },
    h2: {
      color: COLORS.MAIN,
      fontSize: 34,
      fontWeight: 800,
    },
    h3: {
      color: COLORS.VIOLET,
      fontSize: 34,
      fontWeight: 800,
    },
    subtitle1: {
      color: COLORS.MAIN,
      fontSize: 20,
    },
    subtitle2: {
      color: COLORS.BLACK,
      fontSize: 40,
      fontWeight: 800,
    },
  },
  components: {
    MuiLink: {
      styleOverrides: {
        root: {
          color: COLORS.VIOLET,
          fontStyle: 'italic',
          fontWeight: 600,
        },
      },
    },
    MuiSnackbar: {
      defaultProps: {
        anchorOrigin: {
          horizontal: 'center',
          vertical: 'top'
        },
        autoHideDuration: DEFAULT_AUTO_HIDE_DURATION,
        TransitionComponent: Slide,
        transitionDuration: DEFAULT_TRANSITION_DURATION
      },
      styleOverrides: {
        root: ({ theme }) => ({
          top: 0,
          [theme.breakpoints.up('sm')]: {
            top: 0,
          },
      
          '& .MuiAlert-root': {
            borderRadius: '0 0 16px 16px',
            padding: 10,
          },
      
          '& .MuiAlert-icon': {
            padding: '7px 5px',
          },
      
          '& .MuiAlert-message': {
            padding: '8px 20px',
          },
      
          '& .MuiAlert-action': {
            padding: '2px 7px 0 16px',
            // paddingRight: 5,
          },
        })
      }
    },
    MuiAlert: {
      defaultProps: {
        variant: 'filled',
        severity: 'error',
        elevation: 6
      },
      styleOverrides: {
        root: {
          color: COLORS.WHITE,
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          '&.MuiSvgIcon-fontSizeXlarge': {
            fontSize: '3rem',
          }
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          border: 'none',
        }
      }
    }
  }
});

export default MainTheme;
